//image gallery (lightbox)
let currentImageIndex = 0;
let images = document.querySelectorAll('#portfolio img, #artists .artist-artwork, #portfolionew img'); 
const lightbox = document.getElementById('lightbox');
const lightboxImg = lightbox.querySelector('img');

images.forEach(image => {
  image.addEventListener('click', (event) => {
    event.preventDefault(); // Verhindert Standardverhalten des Links
    openModal(image);
  });
});


function openModal(image) {
  currentImageIndex = Array.from(images).indexOf(image);
  lightboxImg.src = image.src;
  lightbox.classList.add('open');
}

function closeModal() {
  lightbox.classList.remove('open');
}

function previousImage() {
  currentImageIndex = (currentImageIndex - 1 + images.length) % images.length;
  lightboxImg.src = images[currentImageIndex].src;
}

function nextImage() {
  currentImageIndex = (currentImageIndex + 1) % images.length;
  lightboxImg.src = images[currentImageIndex].src;
}

const lightboxCloseButtons = document.getElementsByClassName("lightbox-close-button");
for (var i = 0; i < lightboxCloseButtons.length; i++) {
    lightboxCloseButtons[i].addEventListener('click', closeModal, false);
}

const lightboxLeftArrows = document.getElementsByClassName("lightbox-left-arrow");
for (var i = 0; i < lightboxCloseButtons.length; i++) {
    lightboxLeftArrows[i].addEventListener('click', previousImage, false);
}

const lightboxRightArrows = document.getElementsByClassName("lightbox-right-arrow");
for (var i = 0; i < lightboxCloseButtons.length; i++) {
    lightboxRightArrows[i].addEventListener('click', nextImage, false);
}

document.addEventListener('click', function(event) {
  if (event.target === lightbox) {
    closeModal();
  }
});

document.addEventListener('keydown', function(event) {
  if (lightbox.classList.contains('open')) {
    if (event.key === 'ArrowLeft') {
      previousImage();
    } else if (event.key === 'ArrowRight') {
      nextImage();
    } else if (event.key === 'Escape') {
      closeModal();
    }
  }
});
